import { useFormikContext } from "formik";
import VariantInterface from "../../Interfaces/VariantInterface";
import { Field } from "formik";
import Modal from "./ModalSection";
import { translations, formatMoney, getSrcSet, getImageSizes } from "../../Helpers/WindowHelpers";
import VariantModalBodyDisplay from "../Displays/VariantModalBodyDisplay";

interface VariantInputInterface {
    name: string,
    inputType: "radio" | "checkbox",
    variants: VariantInterface[],
    onChange: (e: Event) => void,
    step: number,
    classes?: string
}

const VariantInput = ({ name, inputType, variants, classes, step, onChange }: VariantInputInterface) => {
    const context = useFormikContext<any>();

    const checkIfChecked = (variantId: string, index: number) => {
        if (inputType == "radio") {
            return variantId == context.values[name]?.variantId
        }
        return context.values?.variants ? context.values.variants.find((item: any) => item?.variantId == variantId) != null : false
    }

    return (
        <div className="card-product__list grid grid--sm">
            {(variants ?? []).map((variant, index) => (
                <div key={index} className={`grid__item md--33 width--50`}>
                    <div className={`promo-cards__card ${parseFloat(variant.price) > 0 ? 'is-upsell': ''} ${!variant.available ? 'disabled' : ''} ${checkIfChecked(variant.id, index) ? 'checked' : ''} ${classes || ""}`} key={index}>
                        <div className="promo-cards__top card-element">
                            {variant.featured_image &&
                                <img
                                    className="promo-cards__image d--block"
                                    srcSet={getSrcSet(variant.featured_image?.src, [200, 300, 400, 600])}
                                    alt={variant.title}
                                    loading="lazy"
                                    width={variant.image.width}
                                    height={variant.image.height}
                                    tabIndex={-1}
                                    aria-hidden="true"
                                    sizes={getImageSizes('300px', [
                                        {
                                            screen: 767,
                                            view: '48vw'
                                        },
                                        {
                                            screen: 1099,
                                            view: '30vw'
                                        },
                                        {
                                            screen: 1664,
                                            view: '300px'
                                        }
                                    ])}
                                />
                            }
                            {variant.metafields?.custom?.promotion_badge?.name && <div className="promo-cards__badge promotion-badge">{variant.metafields?.custom?.promotion_badge?.name}</div>}
                        </div>
                        <div className="promo-cards__bottom gap-16 flex-grow">
                            <Field
                                key={index}
                                type={inputType}
                                checked={checkIfChecked(variant.id, index)}
                                name={name}
                                value={variant.id}
                                className="card-product__input visually-hidden"
                                onChange={onChange}
                                disabled={!variant.available}
                                id={`${name}-${index}`}
                            />
                            <label tabIndex={0} className="h5 d--flex gap-4 card-element" htmlFor={`${name}-${index}`}>
                                <span className={`promo-cards__indicator ${inputType == 'radio' ? '' : 'is-checkbox'}`}></span>
                                <div className="d--flex gap-4 flex-wrap--wrap">
                                    {variant.title}
                                </div>
                            </label>
                            {variant.metafields?.custom?.blurb && (
                                <p className="card-product__desc card-element">{variant.metafields?.custom?.blurb}</p>
                            )}
                            {variant.metafields?.custom?.tagline && (
                                <p className="card-product__subtitle card-element color--gray-muted text--sm text--uppercase mb-10">
                                    {variant.metafields.custom.tagline}
                                </p>
                            )}

                            <div className="d--flex xs--flex-column gap-8 justify--space-between mt-auto">
                                {parseFloat(variant.price) > 0 &&
                                    <div className="promo-cards__price d--flex gap-4 card-element">
                                        <span className="price">
                                            +{formatMoney(variant.price)}
                                        </span>
                                        {parseFloat(variant.compare_at_price) > parseFloat(variant.price) && (
                                            <s className="price--compare color--gray-muted ml-5">
                                                {formatMoney(variant.compare_at_price)}
                                            </s>
                                        )}
                                    </div>
                                }
                                <Modal
                                    classes={"link mt-auto sm--100 ml-auto card-element"}
                                    buttonBody={translations.details}
                                >
                                    <VariantModalBodyDisplay
                                        fieldName={name}
                                        variant={variant}
                                        image={variant.featured_image}
                                        step={step}
                                        multiselect={inputType == 'checkbox'}
                                    >
                                    </VariantModalBodyDisplay>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default VariantInput